import { UseCaseError } from '../../../core/errors/UseCaseError';

export class CancelFollowRequest {
  constructor(userRepository) {
    this.userRepository = userRepository;
  }

  /**
   * Annuler une demande d'abonnement en attente
   * @param {string} currentUserId - ID de l'utilisateur qui annule
   * @param {string} targetUserId - ID de l'utilisateur cible
   * @returns {Promise<boolean>} - Résultat de l'opération
   */
  async execute(currentUserId, targetUserId) {
    try {
      console.log(`CancelFollowRequest UseCase - ${currentUserId} annule sa demande à ${targetUserId}`);
      
      if (!currentUserId || !targetUserId) {
        throw new UseCaseError('Les IDs des utilisateurs sont requis');
      }

      await this.userRepository.cancelFollowRequest(currentUserId, targetUserId);
      console.log(`Demande d'abonnement annulée de ${currentUserId} à ${targetUserId}`);
      return true;
    } catch (error) {
      console.error('Erreur dans CancelFollowRequest UseCase:', error);
      throw error;
    }
  }
} 